import * as React from 'react'

import { Box, Link, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import { LOGIN_PATH } from 'modules/payroll_integrations_a3innuva/lib/OauthService'

interface Props {
  companyId: number | undefined
}

const NotAuthenticated = ({ companyId }: Props) => {
  // TODO: make it generic for other integrations
  const isBookkeeperView = useBookkeeperView()
  const loginUrl = buildUrl(
    `${LOGIN_PATH}/?company_id=${companyId}&bookkeeper_view=${isBookkeeperView}`
  )

  return (
    <Box
      background="champagne200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
    >
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.a3innuva.not_authenticated.title')}
      </Text.Header2>
      <Box>{i18n.t('payroll_integrations.incidences.a3innuva.not_authenticated.message')}</Box>
      <Link.Href href={loginUrl}>
        {i18n.t('payroll_integrations.incidences.a3innuva.not_authenticated.submit')}
      </Link.Href>
    </Box>
  )
}

export default NotAuthenticated
